
// import _ from 'lodash';

const namespaced = true;

const state = {
  recurrentIntervention: null,
  clients: [],
  sites: [],
  priorities: [],
  domains: [],
  equipments: [],
  isFetchingClients: false,
  isFetchingSites: false,
  isFetchingPriorities: false,
  isFetchingDomains: false,
  isFetchingEquipments: false,
};

const mutations = {
  SET_RECURRENT_INTERVENTION(state, recurrentIntervention) {
    state.recurrentIntervention = recurrentIntervention;
  },
  SET_CLIENTS(state, clients) {
    state.clients = clients;
  },
  SET_SITES(state, sites) {
    state.sites = sites;
  },
  SET_PRIORITIES(state, priorities) {
    state.priorities = priorities;
  },
  SET_DOMAINS(state, domains) {
    state.domains = domains;
  },
  SET_EQUIPMENTS(state, equipments) {
    state.equipments = equipments;
  },
  SET_IS_FETCHING_CLIENTS(state, isFetchingClients) {
    state.isFetchingClients = isFetchingClients;
  },
  SET_IS_FETCHING_SITES(state, isFetchingSites) {
    state.isFetchingSites = isFetchingSites;
  },
  SET_IS_FETCHING_PRIORITIES(state, isFetchingPriorities) {
    state.isFetchingPriorities = isFetchingPriorities;
  },
  SET_IS_FETCHING_DOMAINS(state, isFetchingDomains) {
    state.isFetchingDomains = isFetchingDomains;
  },
  SET_IS_FETCHING_EQUIPMENTS(state, isFetchingEquipments) {
    state.isFetchingEquipments = isFetchingEquipments;
  },
};

const actions = {
  async setRecurrentIntervention({ commit, state }, recurrentIntervention) {
    commit(`SET_RECURRENT_INTERVENTION`, recurrentIntervention);

    return state.recurrentIntervention;
  },
  async fetchClients({ commit, dispatch, state }) {
    commit(`SET_IS_FETCHING_CLIENTS`, true);
    let clients = [];
    try {
      clients = await dispatch(`model/client/fetchListForMaker`, state.recurrentIntervention.Maker_id, { root: true });
    } catch (e) {} // eslint-disable-line

    commit(`SET_CLIENTS`, clients);
    commit(`SET_IS_FETCHING_CLIENTS`, false);
  },
  async fetchSites({ commit, dispatch, state }) {
    commit(`SET_IS_FETCHING_SITES`, true);
    let sites = [];
    if (state.recurrentIntervention.Client_id) {
      try {
        sites = await dispatch(`model/site/fetchSitesForClient`, state.recurrentIntervention.Client_id, { root: true });
      } catch (e) {} // eslint-disable-line
    }

    commit(`SET_SITES`, sites);
    commit(`SET_IS_FETCHING_SITES`, false);
  },
  async fetchPriorities({ commit, dispatch, state }) {
    commit(`SET_IS_FETCHING_PRIORITIES`, true);
    let priorities = [];
    try {
      priorities = await dispatch(`model/priority/fetchPrioritiesForMaker`, state.recurrentIntervention.Maker_id, { root: true });
    } catch (e) {} // eslint-disable-line

    commit(`SET_PRIORITIES`, priorities);
    commit(`SET_IS_FETCHING_PRIORITIES`, false);
  },
  async fetchDomains({ commit, dispatch, state }) {
    commit(`SET_IS_FETCHING_DOMAINS`, true);
    let domains = [];
    try {
      domains = await dispatch(`model/domain/fetchDomainsForMaker`, state.recurrentIntervention.Maker_id, { root: true });
    } catch (e) {} // eslint-disable-line

    commit(`SET_DOMAINS`, domains);
    commit(`SET_IS_FETCHING_DOMAINS`, false);
  },
  async fetchEquipments({ commit, dispatch, state }) {
    commit(`SET_IS_FETCHING_EQUIPMENTS`, true);
    let equipments = [];
    if (state.recurrentIntervention.Site_id) {
      try {
        const queryParams = {
          client: state.recurrentIntervention.Client_id,
          site: state.recurrentIntervention.Site_id,
          viewAll: 1,
        };
        equipments = await dispatch(`model/equipment/fetchList`, {
          queryParams,
        }, { root: true });
      } catch (e) {} // eslint-disable-line
    }

    commit(`SET_EQUIPMENTS`, equipments);
    commit(`SET_IS_FETCHING_EQUIPMENTS`, false);
  },
  async addRecurrentIntervention({ dispatch, state }) {
    try {
      const recurrentIntervention = await dispatch(`model/recurrentIntervention/add`, state.recurrentIntervention, { root: true });
      dispatch(`setRecurrentIntervention`, recurrentIntervention);
    } catch (e) {} // eslint-disable-line
  },
  async updateRecurrentIntervention({ dispatch, state }) {
    try {
      const recurrentIntervention = await dispatch(`model/recurrentIntervention/update`, state.recurrentIntervention, { root: true });
      dispatch(`setRecurrentIntervention`, recurrentIntervention);
    } catch (e) {} // eslint-disable-line
  },
  async removeRecurrentIntervention({ dispatch, state }) {
    try {
      await dispatch(`model/recurrentIntervention/remove`, state.recurrentIntervention.id, { root: true });
    } catch (e) {} // eslint-disable-line
  },
};

const getters = {
  recurrentIntervention: state => state.recurrentIntervention,
  clients: state => state.clients,
  sites: state => state.sites,
  priorities: state => state.priorities,
  domains: state => state.domains,
  equipments: state => state.equipments,
  isFetchingClients: state => state.isFetchingClients,
  isFetchingSites: state => state.isFetchingSites,
  isFetchingPriorities: state => state.isFetchingPriorities,
  isFetchingDomains: state => state.isFetchingDomains,
  isFetchingEquipments: state => state.isFetchingEquipments,
};

export default {
  namespaced, state, mutations, actions, getters,
};
